module.exports = __webpack_public_path__ + "img/970.9577b90b.jpg";